import React from 'react';

export const Filler = ({ height, width, marginTop, marginBottom, color, className }) => {
   return (
      <React.Fragment>
         <div
            className={className}
            style={{
               marginLeft: 0,
               marginRight: 0,
               marginTop: marginTop ? marginTop : 0,
               marginBottom: marginBottom ? marginBottom : 0,
               borderColor: color,
               width: width,
               height: height,
            }}
         />
      </React.Fragment>
   );
};
